var $ = require('jquery');
var ajax = require('../core/ajax');
var _ = require('../core/lodash');

var i18n = {
	en:{
		"aria": {
			"sortAscending":  ": activate to sort column ascending",
			"sortDescending": ": activate to sort column descending"
		},
		"paginate": {
			"first":      "First",
			"last":       "Last",
			"next":       "Next",
			"previous":   "Previous"
		},
		"emptyTable": "No data available in table",
		"info": "Showing _START_ to _END_ of _TOTAL_ entries",
		"infoEmpty": "Showing 0 to 0 of 0 entries",
		"infoFiltered": "(filtered from _MAX_ total entries)",
		"infoPostFix": "",
		"decimal": "",
		"thousands": ",",
		"lengthMenu": "Show _MENU_ entries",
		"loadingRecords": "Loading...",
		"processing": "Processing...",
		"search": "Search:",
		"searchPlaceholder": "",
		"url": "",
		"zeroRecords": "No matching records found"
	},
	cn:{
		"aria": {
			"sortAscending":  ": 升序排列",
			"sortDescending": ": 降序排列"
		},
		"paginate": {
			"first":      "首页",
			"last":       "末页",
			"next":       "下页",
			"previous":   "上页"
		},
		"emptyTable": "没有相关记录",
		"info": "第 _START_ 到 _END_ 条记录，共 _TOTAL_ 条",
		"infoEmpty": "第 0 到 0 条记录，共 0 条",
		"infoFiltered": "(从 _MAX_ 条记录中检索)",
		"infoPostFix": "",
		"decimal": "",
		"thousands": ",",
		"lengthMenu": "每页显示条数: _MENU_",
		"loadingRecords": "正在载入...",
		"processing": "正在载入...",
		"search": "搜索:",
		"searchPlaceholder": "",
		"url": "",
		"zeroRecords": "没有相关记录"
	}
};
var defaults = {
	language:i18n.cn,
	destroy:true,
	info: true,
	processing: true,
	ordering: false,
	pagingType: 'full_numbers',
	lengthChange: false,
	pageLength: 10,
	searching: false,
	serverSide: true
};


function serverSidePage(data) {
	return {
		draw:data.draw,
		pagination:Math.floor(data.start/data.length)+1,
		pageLength:data.length
	};
}
function serverSideData(json) {
	var recordsFiltered = 0;
	var recordsTotal = 0;
	if(json.data && json.data.length){
		recordsTotal = json.recordsTotal == null?json.data.length : json.recordsTotal;
		recordsFiltered = json.recordsFiltered == null?recordsTotal:json.recordsFiltered;
	}
	return {
		draw:json.draw,
		data:json.data || [],
		recordsTotal:recordsTotal,
		recordsFiltered:recordsFiltered
	};
}

module.exports = function () {
	if (typeof $.fn.dataTable === 'undefined') {
		throw new Error('dataTables method requires datatables.net')
	}

	var DataTable = $.fn.dataTable;

	/* trfDataTable */
	(function () {
		var TrfDataTable   = function (element, options) {
			this.$element   = null;
			this.options    = null;
			this.rawJson    = null;
			this.proxy = {
				draw:$.proxy(function (e, settings) {
					// console.log('drawCallback');
					this.showError();
				}, this),
				init:$.proxy(function () {
					// console.log('initComplete');
					this.initPageChange();
				}, this),
				xhr:$.proxy(function ( e, settings, json, xhr ) {
					// console.log(e, settings, json, xhr);
				}, this),
				destroy:$.proxy(this.destroy, this)
			};
			this.init( element, options);
		};

		TrfDataTable.DEFAULTS = {
			jump: true,//为真时开启跳转到页功能
			dataTableOpt:null
		};

		TrfDataTable.prototype.init = function (element, options) {
			var $element = this.$element  = $(element);
			this.setOptions(options);
			options = this.options;
			if(options.dataTableOpt){
				$element.dataTable(options.dataTableOpt);
				if(!options.dataTableOpt || (options.dataTableOpt && !options.dataTableOpt.destroy)){
					$element.off('draw.dt',this.proxy.draw);
					$element.off('init.dt',this.proxy.init);
					$element.off('xhr.dt',this.proxy.xhr);
					$element.off('destroy.dt',this.proxy.destroy);
				}
				$element.on('draw.dt',this.proxy.draw);
				$element.on('init.dt',this.proxy.init);
				$element.on('xhr.dt',this.proxy.xhr);
				$element.on('destroy.dt',this.proxy.destroy);
			}

		};

		TrfDataTable.prototype.setOptions = function (options) {
			if(this.options){
				 $.extend(true,this.options , options);
				this.initPageChange();
			}else{
				this.options = $.extend(true,{}, TrfDataTable.DEFAULTS, options);
			}
		};
		TrfDataTable.prototype.setRawJson = function (json) {
			this.rawJson = json;
		};
		TrfDataTable.prototype.destroy = function (e, settings) {

		};
		TrfDataTable.prototype.showError = function () {
			var $element = this.$element;
			var rawJson = this.rawJson;

			var dataTables_wrapper = $element.closest('.dataTables_wrapper');
			var bool = !!rawJson && (rawJson.data == null || rawJson.data.length === 0) && rawJson.error!=null;
			dataTables_wrapper.toggleClass('dataTables_error',bool);
			if(bool && rawJson.error.code === 'A01'){
				dataTables_wrapper.find('.dataTables_empty').html(rawJson.error.msg);
			}
		};

		TrfDataTable.prototype.initPageChange = function () {
			var jumpTpl =  '<div class="input-group input-group-sm">' +
				'<input class="form-control __page">' +
				'<div class="input-group-btn"><button class="form-control btn btn-primary __go">GO</button>' +
				'</div>';
			var $element = this.$element;
			var dataTables_wrapper = $element.closest('.dataTables_wrapper');

			// datatables重绘了,必须重新绑定事件
			if(!dataTables_wrapper.data('pageChangeFlag')){
				dataTables_wrapper.data('pageChangeFlag',true);
				dataTables_wrapper.on('click','.__go',function(e){
					var redirect = +dataTables_wrapper.find('.__page').val();
					if(redirect > 0 ){
						$element.DataTable().page(redirect - 1).draw('page');
					}
					dataTables_wrapper.find('.__page').val('');
				});
			}
			if(this.options.jump && dataTables_wrapper.find('.dataTables_jump').is(':empty')){
				dataTables_wrapper.find('.dataTables_jump').html(jumpTpl);
			}else{
				// dataTables_wrapper.find('.dataTables_jump').css({'visibility':'hidden'});
			}
		};

		function Plugin(option) {
			var param = [].slice.call( arguments, 1);
			return this.each(function () {
				var $this = $(this);
				var data  = $this.data('trf.dataTable');
				var options = typeof option == 'object' && option;

				if (!data && /setRawJson|destroy/.test(option)) {
					return;
				}

				if (!data) {
					$this.data('trf.dataTable', (data = new TrfDataTable(this,options)));
				}else if(typeof option != 'string'){
					$this.data('trf.dataTable.dealTiming', null);
					data['init'](this,options);
				}
				if (typeof option == 'string') {
					data[option].apply(data,param);
				}
			})
		}

		$.fn.trfDataTable             = Plugin;
		$.fn.trfDataTable.Constructor = TrfDataTable;

	})();


	/* Set the defaults for DataTables initialisation */
	$.extend( true, DataTable.defaults, {
		dom:
		"<'row'<'col-sm-6'l><'col-sm-6'f>>" +
		"<'row'<'col-sm-12'tr>>" +
		"<'row'<'col-sm-4'i><'col-sm-2 dataTables_jump'><'col-sm-6'p>>",
		renderer: 'bootstrap'
	}, defaults);


	/* Default class modification */
	$.extend( DataTable.ext.classes, {
		sWrapper:      "dataTables_wrapper form-inline dt-bootstrap",
		sFilterInput:  "form-control input-sm",
		sLengthSelect: "form-control input-sm",
		sProcessing:   "dataTables_processing panel panel-default"
	} );


	/* Bootstrap paging button renderer */
	DataTable.ext.renderer.pageButton.bootstrap = function ( settings, host, idx, buttons, page, pages ) {
		var api     = new DataTable.Api( settings );
		var classes = settings.oClasses;
		var lang    = settings.oLanguage.oPaginate;
		var aria = settings.oLanguage.oAria.paginate || {};
		var btnDisplay, btnClass, counter=0;

		var attach = function( container, buttons ) {
			var i, ien, node, button;
			var clickHandler = function ( e ) {
				e.preventDefault();
				if ( !$(e.currentTarget).hasClass('disabled') && api.page() != e.data.action ) {
					api.page( e.data.action ).draw( 'page' );
				}
			};

			for ( i=0, ien=buttons.length ; i<ien ; i++ ) {
				button = buttons[i];

				if ( $.isArray( button ) ) {
					attach( container, button );
				}
				else {
					btnDisplay = '';
					btnClass = '';

					switch ( button ) {
						case 'ellipsis':
							btnDisplay = '&#x2026;';
							btnClass = 'disabled';
							break;

						case 'first':
							btnDisplay = lang.sFirst;
							btnClass = button + (page > 0 ?
									'' : ' disabled');
							break;

						case 'previous':
							btnDisplay = lang.sPrevious;
							btnClass = button + (page > 0 ?
									'' : ' disabled');
							break;

						case 'next':
							btnDisplay = lang.sNext;
							btnClass = button + (page < pages-1 ?
									'' : ' disabled');
							break;

						case 'last':
							btnDisplay = lang.sLast;
							btnClass = button + (page < pages-1 ?
									'' : ' disabled');
							break;

						default:
							btnDisplay = button + 1;
							btnClass = page === button ?
								'active' : '';
							break;
					}

					if ( btnDisplay ) {
						node = $('<li>', {
							'class': classes.sPageButton+' '+btnClass,
							'id': idx === 0 && typeof button === 'string' ?
							settings.sTableId +'_'+ button :
								null
						} )
							.append( $('<a>', {
									'href': '#',
									'aria-controls': settings.sTableId,
									'aria-label': aria[ button ],
									'data-dt-idx': counter,
									'tabindex': settings.iTabIndex
								} )
									.html( btnDisplay )
							)
							.appendTo( container );

						settings.oApi._fnBindAction(
							node, {action: button}, clickHandler
						);

						counter++;
					}
				}
			}
		};

		// IE9 throws an 'unknown error' if document.activeElement is used
		// inside an iframe or frame.
		var activeEl;

		try {
			// Because this approach is destroying and recreating the paging
			// elements, focus is lost on the select button which is bad for
			// accessibility. So we want to restore focus once the draw has
			// completed
			activeEl = $(host).find(document.activeElement).data('dt-idx');
		}
		catch (e) {}

		attach(
			$(host).empty().html('<ul class="pagination"/>').children('ul'),
			buttons
		);

		if ( activeEl !== undefined ) {
			$(host).find( '[data-dt-idx='+activeEl+']' ).focus();
		}
	};


	return {
		i18n:i18n,// 国际化
		/**
		 * 生成 DataTable配置Options.ajax
		 */
		ajax:{
			/**
			 *
			 * @param options 参见trf.ajax
			 * @param ajaxCallback  可以通过该方法处理除了展示data列表数据，之外的数据
			 * @returns {Function}
			 */
			simple:function (options,ajaxCallback) {
				return function (data, callback, settings) {
					var self = $(this);
					self.trfDataTable('setRawJson',null);
					options = $.extend(true,options||{}, {
						data: serverSidePage(data)
					});
					//当前表格有排序功能，与后台协定传 orderType='name-asc' columns 将name属性传过来
					if(data.order.length>0){
						var order = data.order[0] || {};
						options.data.orderType = data.columns[order.column].name + '-' + order.dir;
					}
					return ajax(options).then(function (json) {
						self.trfDataTable('setRawJson',json);
						callback(serverSideData(json));
                        typeof ajaxCallback === 'function' && ajaxCallback.call(null,json);
					});
				};
			},
			pageSeparate:function (options) {
				var defaults = {
					dataAjax:{},//数据trf.ajax的options
					recordAjax:{},//数据trf.ajax的options
					timing:false,//是否定时刷新
					timingAjax:null//数据trf.ajax的options，为null时取dataAjax
				};
				var records = null;

				var dealRecords = _.once(function (options,data,callback) {
					return ajax(options.recordAjax).then(function (json) {
						var recordsTotal = json.recordsTotal;

						if(json.error == null || (json.error && json.error.code==0) ){
							records = {
								recordsFiltered:recordsTotal,
								recordsTotal:recordsTotal
							};
							data.recordsFiltered = recordsTotal;
							data.recordsTotal = recordsTotal;
							callback(serverSideData(data));
						}
					});
				});
				function dealTiming(options,callback,self) {
					clearTimeout(dealTiming.timeoutId);
					dealTiming.timeoutId = setTimeout(function () {
						if(self.data('trf.dataTable.dealTiming')===dealTiming){
							ajax(options.timingAjax||options.dataAjax).then(function (json) {
								if(records){
									json.recordsFiltered = records.recordsFiltered;
									json.recordsTotal = records.recordsTotal;
								}

								callback(serverSideData(json));
								return json;
							})['finally'](function () {
								if(self.data('trf.dataTable.dealTiming')===dealTiming){
									dealTiming(options,callback,self);
								}
							});
						}
					},$.type(options.timing)==='number'?options.timing:1000*60)
				}
				dealTiming.timeoutId = null;

				function dealData(options,callback,self) {
					return ajax(options.dataAjax).then(function (json) {
						if(records){
							json.recordsFiltered = records.recordsFiltered;
							json.recordsTotal = records.recordsTotal;
						}
						//获取分页
						dealRecords(options,json,callback);

						callback(serverSideData(json));

						if(options.timing){
							self.data('trf.dataTable.dealTiming', dealTiming);
							dealTiming(options,callback,self);
						}else{
							self.data('trf.dataTable.dealTiming', null);
						}

						return json;
					});
				}


				return function (data, callback, settings) {
					var self = $(this);
					self.trfDataTable('setRawJson',null);
					options = options ||{};
					options = $.extend(true,{},defaults,options||{});
					$.extend(true,options.dataAjax, {
						data: serverSidePage(data)
					});
					$.extend(true,options.recordAjax, {
						data: serverSidePage(data)
					});

					return dealData(options,callback,self).then(function (json) {
						self.trfDataTable('setRawJson',json);
					});
				};
			}
		}
	};
};



//////////////////
// WEBPACK FOOTER
// ./src/plugins/dataTables.js
// module id = 198
// module chunks = 0